type StruckValueProps = {
  struck: boolean;
  children: React.ReactNode;
};

// Rejected value: real CSS line-through (wraps correctly) + greyed text, with the
// colour change animated. line-through toggles only when struck — the palette has no
// top-level decoration-colour token, so we gate the utility itself rather than its colour.
export const StruckValue = ({ struck, children }: StruckValueProps) => (
  <span
    className={`t-text-body t-break-words t-transition-colors t-duration-300 ${
      struck ? "t-text-neutral-50 t-line-through" : "t-text-text-100"
    }`}
  >
    {children}
  </span>
);
